import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "./i18n/LanguageContext";
import Layout from "./components/layout/Layout";

import Home from "./pages/Home";
import PortailsOverview from "./pages/PortailsOverview";
import ProductPage from "./pages/ProductPage";
import LocalPage from "./pages/LocalPage";
import Realisations from "./pages/Realisations";
import Zones from "./pages/Zones";
import { ConseilsList, ConseilArticle } from "./pages/Conseils";
import Contact from "./pages/Contact";
import { MentionsLegales, Confidentialite } from "./pages/Legal";
import NotFound from "./pages/NotFound";

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />

                    {/* Product overview */}
                    <Route path="/portails" element={<PortailsOverview />} />

                    {/* Product pages — explicit slugs */}
                    <Route path="/portail-aluminium" element={<ProductPage />} />
                    <Route path="/portail-coulissant" element={<ProductPage />} />
                    <Route path="/portail-battant" element={<ProductPage />} />
                    <Route path="/clotures" element={<ProductPage />} />
                    <Route path="/brise-vue" element={<ProductPage />} />
                    <Route path="/motorisation-portail" element={<ProductPage />} />

                    {/* Local SEO pages */}
                    <Route path="/portail-geneve" element={<LocalPage />} />
                    <Route path="/portail-pays-de-gex" element={<LocalPage />} />
                    <Route path="/portail-gex" element={<LocalPage />} />
                    <Route path="/portail-ferney-voltaire" element={<LocalPage />} />
                    <Route path="/portail-divonne-les-bains" element={<LocalPage />} />
                    <Route path="/portail-saint-genis-pouilly" element={<LocalPage />} />
                    <Route path="/portail-annemasse" element={<LocalPage />} />
                    <Route path="/portail-haute-savoie" element={<LocalPage />} />
                    <Route path="/brise-vue-geneve" element={<LocalPage />} />
                    <Route path="/cloture-pays-de-gex" element={<LocalPage />} />

                    <Route path="/realisations" element={<Realisations />} />
                    <Route path="/zones-intervention" element={<Zones />} />
                    <Route path="/conseils" element={<ConseilsList />} />
                    <Route path="/conseils/:slug" element={<ConseilArticle />} />
                    <Route path="/contact" element={<Contact />} />

                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/confidentialite" element={<Confidentialite />} />

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Layout>
            <Toaster
                theme="dark"
                position="top-right"
                richColors
                toastOptions={{
                    style: { background: "#0E1721", border: "1px solid rgba(0,194,199,0.25)", color: "#F1F5F9" },
                }}
            />
        </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
